import React from 'react';
import { FolderSearch } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NoResultsFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4" data-testid="no-results-found">
      {/* Icon */}
      <div className="mb-6 relative">
        <FolderSearch size={120} className="text-gray-300" strokeWidth={1.5} />
        {/* Decorative plus signs */}
        <div className="absolute -top-2 -left-2 text-gray-300 text-xl">+</div>
        <div className="absolute -top-4 -right-4 text-gray-300 text-sm">+</div>
        <div className="absolute -bottom-2 -left-4 text-gray-300 text-sm">+</div>
      </div>
      
      {/* Text */}
      <h3 className="text-lg font-medium text-gray-600">
        {t('common.noResultsFound', 'No results found')}
      </h3>
    </div>
  );
};

export default React.memo(NoResultsFound);